export default __webpack_public_path__ + "static/media/Snd_LowerDDownBump.5c32d9e5.mp3";